/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Matching_Score_Category_Soft_SkillsInputs */

const en_matching_score_category_soft_skills = /** @type {(inputs: Matching_Score_Category_Soft_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soft skills`)
};

const de_matching_score_category_soft_skills = /** @type {(inputs: Matching_Score_Category_Soft_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soft Skills`)
};

/**
* | output |
* | --- |
* | "Soft skills" |
*
* @param {Matching_Score_Category_Soft_SkillsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const matching_score_category_soft_skills = /** @type {((inputs?: Matching_Score_Category_Soft_SkillsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Matching_Score_Category_Soft_SkillsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_matching_score_category_soft_skills(inputs)
	return en_matching_score_category_soft_skills(inputs)
});